import * as React from "react";
import { ACTIVE_LEAD_STATUSES } from "../lead-status";

// 리드 상태 <option> 목록 (활성 11). Select 안에 그대로 넣어 씀.
// 필터용으로 앞에 "전체" 옵션이 필요하면 이 컴포넌트 앞에 <option value="">를 둔다.
export function LeadStatusOptions(): React.ReactElement {
  return (
    <>
      {ACTIVE_LEAD_STATUSES.map((m) => (
        <option key={m.value} value={m.value}>
          {m.label}
        </option>
      ))}
    </>
  );
}
